// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".md-field{border-radius:5px}.slide-div{margin-bottom:30px;min-height:420px;overflow-x:hidden;overflow-y:auto}@media screen and (max-width:800px){.slide-div{min-height:100px!important}}.md-checkbox .md-checkbox-container{border-radius:50%!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
